import React, { useEffect, useMemo, useState } from "react";
import { string, node } from "prop-types";
import Modal from "../Modal/Modal.jsx";

const propTypes = {
  children: node,
  matterportId: string,
};

const VirtualTourButton = props => {
  const { children, matterportId, ...otherProps } = props;

  const [isOpen, toggleOpen] = useState(false);

  const getWidth = () => window.innerWidth * (3 / 4);

  const [width, setWidth] = useState(getWidth());
  const height = useMemo(() => width * (480 / 853), [width]);

  useEffect(() => {
    const handleResize = e => {
      setWidth(getWidth());
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!matterportId) {
    return null;
  }

  const matterportURL = matterportId;
  // const matterportURL = matterportId.split("?")[0] + "?m=" + matterportId + "&qs=1&mt=1&ts=1&play=1&mls=1";
  return (
    <React.Fragment>
      <button type="button" onClick={() => toggleOpen(true)} {...otherProps}>
        {children}
      </button>

      <Modal isOpen={isOpen} onClose={() => toggleOpen(false)}>
        <iframe
          width={width}
          height={height}
          src={`${matterportURL}`}
          frameBorder="0"
          allowFullScreen
          allow="vr"
          title="Virtual tour"
          style={{ maxWidth: "100%" }}
        ></iframe>
      </Modal>
    </React.Fragment>
  );
};

VirtualTourButton.propTypes = propTypes;
export default VirtualTourButton;
